export const URL_EVENTS = {
  URL_CHANGED: "url_changed",
  FORCE_RELOAD: "force_reload",
  FOCUS_FILTER_SECTION: "focus_filter_section",
  FOCUS_JEWELRY_TYPE: "focus_jewelry_type",
};

type EventCallback = (...args: any[]) => void;

class CustomEventEmitter {
  private listeners: Record<string, EventCallback[]> = {};

  on(event: string, callback: EventCallback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);

    return () => this.off(event, callback);
  }

  off(event: string, callback: EventCallback) {
    if (!this.listeners[event]) return;
    this.listeners[event] = this.listeners[event].filter(
      (cb) => cb !== callback
    );
  }

  emit(event: string, ...args: any[]) {
    if (!this.listeners[event]) return;
    this.listeners[event].forEach((callback) => {
      try {
        callback(...args);
      } catch (error) {
        console.error(`Error in event listener for ${event}:`, error);
      }
    });
  }
}

const urlEventEmitter = new CustomEventEmitter();

export default urlEventEmitter;
